export default __webpack_public_path__ + "static/media/CNo.12-1.e9beb4e3.jpg";